import api from './axios';

export async function fetchKpaReviews({ reviewTypeId, contractId, employeeId }) {
    const params = { review_type_id: reviewTypeId };
    if (contractId) params.contract_id = contractId;
    if (employeeId) params.employee_id = employeeId;
    const { data } = await api.get('/api/kpa-reviews', { params });
    return data; // { contract, review_type_id, data: [{kpa:{...}, review:{...}}] }
}

export async function updateKpaEmployeeComment(kpaReviewId, employeeComment) {
    const { data } = await api.put(`/api/kpa-reviews/${kpaReviewId}/employee-comment`, {
        employee_comment: employeeComment ?? null,
    });
    return data;
}

export async function updateKpaManagerComment(kpaReviewId, managerComment) {
    const { data } = await api.put(`/api/kpa-reviews/${kpaReviewId}/manager-comment`, {
        manager_comment: managerComment ?? null,
    });
    return data;
}